import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AuthService } from '../model/auth.service';

/**
 * Хук для получения Intercom JWT для Identity Verification
 *
 * JWT автоматически обновляется каждые 30 минут (половина от exp = 1 час)
 * и при возврате на вкладку браузера
 *
 * @param enabled - включить/выключить запрос (по умолчанию true)
 */
export function useIntercomJwt(t0) {
  const $ = _c(3);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["intercom-jwt"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      queryKey: t1,
      queryFn: _temp,
      enabled,
      staleTime: 1800000,
      gcTime: 3600000,
      refetchInterval: 1800000,
      refetchOnWindowFocus: true,
      retry: 3
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useQuery(t2);
}
function _temp() {
  return AuthService.getIntercomJwt();
}